import { DEPARTMENT } from './departments';

const { REGISTER, FINANCES } = DEPARTMENT;

const REGISTER_CHAT_ACTION = {
  GLOVO_REGISTRATION: 'glovoRegistration',
  WOLT_REGISTRATION: 'woltRegistration',
  STUART_REGISTRATION: 'stuartRegistration',
  FREE_NOW_REGISTRATION: 'freeNowRegistration',
  BOLT_REGISTRATION: 'boltRegistration',
  BLIQ_REGISTRATION: 'bliqRegistration',
  BOLT_FOOD_REGISTRATION: 'boltFoodRegistration',
  UBER_INVITE: 'uberInvite',
  UBER_EATS_INVITE: 'uberEatsInvite',
  ADD_VEHICLE: 'addVehicle',
  CHECK_SUPPORT: 'checkSupport',
  BOLT_ASSIGN_CAR: 'boltAssignCar',
  FREE_NOW_INVITE: 'freeNowInvite',
  CHANGE_PARTNER: 'changePartner',
  PORTAL_PERGAMIN: 'portalPergamin',
  UPDATE_DOCUMENTS: 'updateDocuments',
  OFFICE_APPOINTMENT: 'officeAppointment',
  TOGGLE_CASH_RIDES: 'toggleCashRides',
};

const REGISTER_CHAT_ACTIONS = [
  {
    text: '1. Glovo регистрация',
    value: REGISTER_CHAT_ACTION.GLOVO_REGISTRATION,
  },
  {
    text: '2. Wolt регистрация',
    value: REGISTER_CHAT_ACTION.WOLT_REGISTRATION,
  },
  {
    text: '3. Stuart регистрация',
    value: REGISTER_CHAT_ACTION.STUART_REGISTRATION,
  },
  {
    text: '4. FreeNow регистрация',
    value: REGISTER_CHAT_ACTION.FREE_NOW_REGISTRATION,
  },
  {
    text: '5. Bolt Taxi регистрация',
    value: REGISTER_CHAT_ACTION.BOLT_REGISTRATION,
  },
  {
    text: '6. Bliq регистрация',
    value: REGISTER_CHAT_ACTION.BLIQ_REGISTRATION,
  },
  {
    text: '7. BoltFood регистрация',
    value: REGISTER_CHAT_ACTION.BOLT_FOOD_REGISTRATION,
  },
  {
    text: '8. Uber Taxi приглашение',
    value: REGISTER_CHAT_ACTION.UBER_INVITE,
  },
  {
    text: '9. UberEats приглашение',
    value: REGISTER_CHAT_ACTION.UBER_EATS_INVITE,
  },
  {
    text: '10. Добавить авто',
    value: REGISTER_CHAT_ACTION.ADD_VEHICLE,
  },
  {
    text: '11. Проверка/Поддержка',
    value: REGISTER_CHAT_ACTION.CHECK_SUPPORT,
  },
  {
    text: '12. Приписка авто в Bolt Taxi',
    value: 'boltAssignCar',
  },
  {
    text: '13. FreeNow приглашение',
    value: REGISTER_CHAT_ACTION.FREE_NOW_INVITE,
  },
  {
    text: '14. Смена партнера',
    value: REGISTER_CHAT_ACTION.CHANGE_PARTNER,
  },
  {
    text: '15. Портал Pergamin',
    value: REGISTER_CHAT_ACTION.PORTAL_PERGAMIN,
  },
  {
    text: '16. Обновить документы',
    value: REGISTER_CHAT_ACTION.UPDATE_DOCUMENTS,
  },
  {
    text: '17. Запись в офис',
    value: REGISTER_CHAT_ACTION.OFFICE_APPOINTMENT,
  },
  {
    text: '18. Отключить/Включить наличные',
    value: REGISTER_CHAT_ACTION.TOGGLE_CASH_RIDES,
  },
];

const FINANCES_CHAT_ACTION = {
  NEW_CONTRACT_DELIVERY: 'newContractDelivery',
  NEW_CONTRACT_TAXI: 'newContractTaxi',
  CONTRACT_LITLEO: 'contractLitleo',
  CONTRACT_FOR_CURRENT_VEHICLE: 'contractForCurrentVehicle',
  CONTRACT_FOR_CURRENT_DATA: 'contractForCurrentData',
  UPDATE_FORM: 'updateForm',
  ADD_DELIVERY: 'addDelivery',
  ADD_TAXI: 'addTaxi',
  REVOKED_CONTRACTS_RESEND: 'revokedContractsResend',
  CONTRACT_SIGN: 'contractSign',
  CHECK_PAYOUT: 'checkPayout',
  CHECK_SOCIAL_INSURANCE: 'checkSocialInsurance',
  FLAT_RATE_TAX: 'flatRateTax',
  CHECK_FRIEND_BONUS: 'checkFriendBonus',
  CHANGE_ACCOUNT_NUMBER: 'changeAccountNumber',
  CHANGE_TARIFF: 'changeTariff',
  HUNTING_FISHING: 'huntingFishing',
  BOLT_WRAP_QUESTION: 'boltWrapQuestion',
  BAILIFF: 'bailiff',
  DISABLE_CASH_UBER: 'disableCashUber',
  ASSIGN_KEY: 'assignKey',
  REASSIGN: 'reassign',
  CALL_REQUEST: 'callRequest',
  INVOICE: 'invoice',
  OTHER_QUESTIONS: 'otherQuestions',
};

const FINANCES_CHAT_ACTIONS = [
  {
    text: 'Новый Договор/доставка',
    value: FINANCES_CHAT_ACTION.NEW_CONTRACT_DELIVERY,
  },
  {
    text: 'Новый договор/такси',
    value: FINANCES_CHAT_ACTION.NEW_CONTRACT_TAXI,
  },
  { text: 'Договор Litleo', value: FINANCES_CHAT_ACTION.CONTRACT_LITLEO },
  {
    text: 'Договор на акт. авто',
    value: FINANCES_CHAT_ACTION.CONTRACT_FOR_CURRENT_VEHICLE,
  },
  {
    text: 'Договора на акт. данные',
    value: FINANCES_CHAT_ACTION.CONTRACT_FOR_CURRENT_DATA,
  },
  { text: 'Изменения в анкету', value: FINANCES_CHAT_ACTION.UPDATE_FORM },
  { text: 'Добавить доставку', value: FINANCES_CHAT_ACTION.ADD_DELIVERY },
  { text: 'Добавить такси', value: FINANCES_CHAT_ACTION.ADD_TAXI },
  {
    text: 'Отозванные договора - переотправка',
    value: FINANCES_CHAT_ACTION.REVOKED_CONTRACTS_RESEND,
  },
  { text: 'Подписал договор', value: FINANCES_CHAT_ACTION.CONTRACT_SIGN },
  { text: 'Чек выплата', value: FINANCES_CHAT_ACTION.CHECK_PAYOUT },
  { text: 'Чек ZUS', value: FINANCES_CHAT_ACTION.CHECK_SOCIAL_INSURANCE },
  { text: 'Ryczalt', value: FINANCES_CHAT_ACTION.FLAT_RATE_TAX },
  {
    text: 'Чек бонус за друга',
    value: FINANCES_CHAT_ACTION.CHECK_FRIEND_BONUS,
  },
  { text: 'Смена счета', value: FINANCES_CHAT_ACTION.CHANGE_ACCOUNT_NUMBER },
  { text: 'Смена типа выплат', value: FINANCES_CHAT_ACTION.CHANGE_TARIFF },
  { text: 'Охота/Рыбалка', value: FINANCES_CHAT_ACTION.HUNTING_FISHING },
  {
    text: 'Вопрос по оклейке Bolt',
    value: FINANCES_CHAT_ACTION.BOLT_WRAP_QUESTION,
  },
  { text: 'Коморник', value: FINANCES_CHAT_ACTION.BAILIFF },
  { text: 'Откл нал в Uber', value: FINANCES_CHAT_ACTION.DISABLE_CASH_UBER },
  { text: 'Приписать ключ', value: FINANCES_CHAT_ACTION.ASSIGN_KEY },
  { text: 'Перепривязка', value: FINANCES_CHAT_ACTION.REASSIGN },
  { text: 'Запрос звонка', value: FINANCES_CHAT_ACTION.CALL_REQUEST },
  { text: 'Фактуры', value: FINANCES_CHAT_ACTION.INVOICE },
  { text: 'Доп. вопросы', value: FINANCES_CHAT_ACTION.OTHER_QUESTIONS },
];

const CHAT_ACTIONS_MAP = {
  [REGISTER]: REGISTER_CHAT_ACTIONS,
  [FINANCES]: FINANCES_CHAT_ACTIONS,
};

const CHAT_ACTION_TAG = {
  LETBE: 'letbe',
  LITLEO: 'litleo',
};

const CHAT_ACTION_TAGS = [
  { text: 'LetBe', value: CHAT_ACTION_TAG.LETBE },
  { text: 'LitLeo', value: CHAT_ACTION_TAG.LITLEO },
];

export {
  CHAT_ACTIONS_MAP,
  CHAT_ACTION_TAG,
  CHAT_ACTION_TAGS,
  REGISTER_CHAT_ACTION,
};
